import { render, staticRenderFns } from "./FChildFields.vue?vue&type=template&id=1513647b&scoped=true"
import script from "./FChildFields.vue?vue&type=script&lang=js"
export * from "./FChildFields.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1513647b",
  null
  
)

export default component.exports